import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Plus } from "lucide-react";
import { SERVICES } from "@/lib/siteData";
import { FadeUp } from "./Shared";

const Row = ({ s, i }) => {
  const [open, setOpen] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-6%" }}
      transition={{ duration: 0.6, delay: (i % 4) * 0.05 }}
      data-testid={`service-row-${i}`}
      className="group border-t border-[var(--line)] last:border-b"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid={`service-toggle-${i}`}
        className="w-full flex items-center gap-5 md:gap-10 py-7 md:py-9 text-left"
      >
        <span className="font-mono-plex text-xs text-[var(--muted)] w-8 shrink-0">{s.no}</span>
        <span className="font-serif-display font-light text-2xl md:text-4xl lg:text-5xl tracking-tight flex-1 transition-transform duration-500 group-hover:translate-x-2">
          {s.title}
        </span>
        <span className="shrink-0 grid place-items-center h-9 w-9 rounded-full border border-[var(--line)] text-[var(--off)] transition-all duration-500 group-hover:bg-[var(--off)] group-hover:text-[#060606]">
          <Plus size={16} className={`transition-transform duration-500 ${open ? "rotate-45" : ""}`} />
        </span>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
          >
            <div className="pb-9 pl-[52px] md:pl-[72px] flex flex-col md:flex-row md:items-end md:justify-between gap-6">
              <p className="max-w-2xl text-base md:text-lg text-[var(--off)]/70 leading-relaxed">{s.desc}</p>
              <a
                href="#consult"
                data-testid={`service-learn-${i}`}
                className="group/l inline-flex items-center gap-2 font-mono-plex text-[11px] uppercase tracking-[0.2em] text-[var(--off)] whitespace-nowrap link-underline pb-1 self-start"
              >
                Learn More <ArrowUpRight size={14} className="transition-transform duration-300 group-hover/l:translate-x-0.5 group-hover/l:-translate-y-0.5" />
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export const Services = () => (
  <section id="services" data-testid="services-section" className="px-6 md:px-12 py-24 md:py-40 bg-[#060606]">
    <div className="mx-auto max-w-[1500px]">
      <FadeUp className="flex items-baseline gap-4 mb-14 md:mb-20 border-b border-[var(--line)] pb-6">
        <span className="font-mono-plex text-xs text-[var(--muted)]">02</span>
        <span className="font-mono-plex text-xs uppercase tracking-[0.28em] text-[var(--muted)]">Practice Areas</span>
      </FadeUp>
      <FadeUp className="max-w-3xl mb-12 md:mb-16">
        <h2 className="font-serif-display font-light text-4xl md:text-6xl tracking-tight leading-[0.95]">
          Eight disciplines of <span className="italic">civil & revenue</span> counsel.
        </h2>
      </FadeUp>
      <div>
        {SERVICES.map((s, i) => (
          <Row key={s.no} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
